import { useEffect, useState, type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './use-auth';
import { useAuthStore } from './auth.store';

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const location = useLocation();
  const { isAuthenticated } = useAuth();
  const status = useAuthStore((s) => s.status);
  const [hydrating, setHydrating] = useState(status === 'idle');

  useEffect(() => {
    if (status === 'idle') {
      useAuthStore
        .getState()
        .hydrate()
        .finally(() => setHydrating(false));
    }
  }, [status]);

  if (hydrating) return null;

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  return <>{children}</>;
}
